module.exports = __webpack_public_path__ + "img/g_qing.049a8b3d.png";